import { Box, Spacer } from "@chakra-ui/react";


export default function Startorder(){
    return (
        <Box>
            <Spacer h={"150px"}/>
            Start order
        </Box>
    )
}